export const report = {
  // Вкладка «Отчет по наряду»
  taskReport: {
    view: '[perm]-[report]-view-task-report',
    create: '[perm]-[report]-create-task-report',
    export: '[perm]-[report]-export-task-report',
  },

  // Вкладка «Сводный отчет»
  summaryReport: {
    view: '[perm]-[report]-view-task-summary-report',
    create: '[perm]-[report]-create-task-summary-report',
    export: '[perm]-[report]-export-task-summary-report',
  },

  // Вкладка «Падеж»
  mortalityReport: {
    view: '[perm]-[report]-view-mortality-report',
    create: '[perm]-[report]-create-mortality-report',
    export: '[perm]-[report]-export-mortality-report',
  },

  //   Ежедневная сводка
  receiveStatusMail: '[perm]-[report]-receive-status-mail',
} as const;
